import { convertPxsToRems } from '@openbank/cf-ui-framework';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';

export const PDF_VIEWER_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: '100%',
  height: convertPxsToRems({ pixels: 252, base: 16 }),
};

export const PDF_TITLE_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_1175,
  height: FoundationsCobrandedRegularTheme.size_300,
};

export const FINANCIAL_DATA_NAME_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_1100,
  height: FoundationsCobrandedRegularTheme.size_250,
};

export const FINANCIAL_DATA_AMOUNT_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: FoundationsCobrandedRegularTheme.size_500,
  height: FoundationsCobrandedRegularTheme.size_250,
};
